import DashboardClientLayout from "../../Layouts/DashboardClientLayout";
import "./HomePage.css";

function ChevronIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 4a5 5 0 0 0-5 5v2.5c0 .9-.3 2.1-.8 3l-.9 1.5h13.4l-.9-1.5c-.5-.9-.8-2.1-.8-3V9a5 5 0 0 0-5-5Z" />
      <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="7" y="4" width="10" height="16" rx="2.5" />
      <path d="M10 18h4" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="m5.5 8.5 6.5 5 6.5-5" />
    </svg>
  );
}

function CardIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="M4 10h16" />
    </svg>
  );
}

function ChatIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 5.5h14a2 2 0 0 1 2 2V15a2 2 0 0 1-2 2H10l-4.5 3v-3H5a2 2 0 0 1-2-2V7.5a2 2 0 0 1 2-2Z" />
      <path d="M8 10h8M8 13h5" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="5" width="16" height="15" rx="2.5" />
      <path d="M8 3.5v3M16 3.5v3M4 10h16" />
    </svg>
  );
}

function TagIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 11V5h6l8 8-6 6-8-8Z" />
      <circle cx="8" cy="8" r="1.2" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3.5 19 6.4v5.2c0 4.4-3 7.8-7 9.4-4-1.6-7-5-7-9.4V6.4L12 3.5Z" />
      <path d="m8.5 12.1 2.4 2.4 4.8-5" />
    </svg>
  );
}

function StatusDot({ tone = "green" }) {
  return <span className={`nc-status-dot ${tone}`} aria-hidden="true" />;
}

function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m7.8 12.1 2.4 2.4 5-5.6" />
    </svg>
  );
}

function Toggle({ checked }) {
  return (
    <span className={`nc-toggle ${checked ? "is-on" : "is-off"}`} aria-hidden="true">
      <span />
    </span>
  );
}

function ChannelRow({ icon, title, desc, checked }) {
  const Icon = icon;
  return (
    <div className="nc-row">
      <span className="nc-row-icon">
        <Icon />
      </span>
      <div className="nc-row-copy">
        <strong>{title}</strong>
        <small>{desc}</small>
      </div>
      <Toggle checked={checked} />
    </div>
  );
}

function PrefRow({ icon, title, desc, push = true, email = true, sms = false }) {
  const Icon = icon;
  return (
    <div className="nc-pref-row">
      <span className="nc-row-icon">
        <Icon />
      </span>
      <div className="nc-row-copy">
        <strong>{title}</strong>
        <small>{desc}</small>
      </div>
      <span className="nc-pref-head">
        <BellIcon />
        <MailIcon />
        <ChatIcon />
      </span>
      <span className={`nc-pref-check ${push ? "is-on" : ""}`}>{push ? <CheckIcon /> : null}</span>
      <span className={`nc-pref-check ${email ? "is-on" : ""}`}>{email ? <CheckIcon /> : null}</span>
      <span className={`nc-pref-check ${sms ? "is-on" : ""}`}>{sms ? <CheckIcon /> : null}</span>
    </div>
  );
}

function DoNotDisturbToggle() {
  return (
    <span className="nc-dnd-toggle is-on" aria-hidden="true"><span /></span>
  );
}

function PreviewBullet({ label, active }) {
  return (
    <div className="nc-preview-bullet">
      <StatusDot tone={active ? "green" : "muted"} />
      <span>{label}</span>
      <em>{active ? "Activé" : "Désactivé"}</em>
    </div>
  );
}

function RecentItem({ icon, tone, title, desc, time, status }) {
  const Icon = icon;
  return (
    <div className="nc-recent-row">
      <span className={`nc-recent-icon ${tone}`}>
        <Icon />
      </span>
      <div className="nc-recent-copy">
        <strong>{title}</strong>
        <span>{desc}</span>
        <small>{time}</small>
      </div>
      <StatusDot tone={tone} />
      {status ? <span className={`nc-recent-pill ${tone}`}>{status}</span> : null}
    </div>
  );
}

export default function NotificationsClient() {
  return (
    <>
      <div className="nc-hero">
        <h1>Notifications</h1>
        <p>Gérez vos préférences de notification et choisissez comment rester informé.</p>
      </div>

      <div className="nc-layout">
        <section className="nc-main">
          <article className="nc-card">
            <div className="nc-card-head">
              <h2>Canaux de notification</h2>
            </div>
            <div className="nc-rows">
              <ChannelRow icon={PhoneIcon} title="Notifications push" desc="Recevez des notifications sur votre téléphone" checked />
              <ChannelRow icon={MailIcon} title="E-mails" desc="Recevez des notifications par e-mail" checked />
              <ChannelRow icon={ChatIcon} title="SMS" desc="Recevez des notifications par SMS" checked={false} />
            </div>
          </article>

          <article className="nc-card">
            <div className="nc-card-head nc-card-head-table">
              <h2>Préférences de notification</h2>
              <span className="nc-table-icons">
                <span><BellIcon /></span>
                <span><MailIcon /></span>
                <span><ChatIcon /></span>
              </span>
            </div>
            <div className="nc-pref-list">
              <PrefRow icon={CalendarIcon} title="Réservations et trajets" desc="Confirmations, rappels et mises à jour de trajets" push email sms={false} />
              <PrefRow icon={TagIcon} title="Offres et promotions" desc="Offres spéciales, réductions et nouveautés" push email sms />
              <PrefRow icon={CardIcon} title="Paiements et facturation" desc="Reçus, remboursements et alertes de paiement" push email sms={false} />
              <PrefRow icon={ShieldIcon} title="Sécurité et compte" desc="Connexion, sécurité et alertes importantes" push email sms />
              <PrefRow icon={ChatIcon} title="Service et assistance" desc="Réponses, enquêtes et communications" push={false} email sms={false} />
              <PrefRow icon={BellIcon} title="Actualités" desc="Nouvelles fonctionnalités et annonces" push={false} email={false} sms={false} />
            </div>
          </article>

          <article className="nc-card nc-dnd-card">
            <div className="nc-dnd-head">
              <span className="nc-dnd-icon">
                <BellIcon />
              </span>
              <div>
                <h2>Ne pas déranger</h2>
                <p>Désactivez les notifications pendant une période donnée.</p>
              </div>
              <DoNotDisturbToggle />
            </div>

            <div className="nc-dnd-form">
              <label>
                <span>De</span>
                <button type="button" className="nc-select">
                  <strong>22:00</strong>
                  <ChevronIcon />
                </button>
              </label>
              <label>
                <span>À</span>
                <button type="button" className="nc-select">
                  <strong>07:00</strong>
                  <ChevronIcon />
                </button>
              </label>
              <label className="nc-dnd-days">
                <span>Jours</span>
                <button type="button" className="nc-select">
                  <strong>Tous les jours</strong>
                  <ChevronIcon />
                </button>
              </label>
            </div>

            <p className="nc-dnd-note">
              Les notifications critiques (sécurité, paiements) seront toujours envoyées.
            </p>
          </article>
        </section>

        <aside className="nc-sidebar">
          <article className="nc-side-card">
            <div className="nc-preview-bell">
              <div className="nc-preview-circle">
                <BellIcon />
              </div>
              <span className="nc-preview-check"><ShieldIcon /></span>
            </div>
            <div className="nc-preview-copy">
              <strong>Vous êtes à jour !</strong>
              <p>Vos préférences de notifications sont bien configurées.</p>
            </div>
            <div className="nc-preview-list">
              <PreviewBullet label="Push" active />
              <PreviewBullet label="E-mails" active />
              <PreviewBullet label="SMS" active={false} />
            </div>
          </article>

          <article className="nc-side-card">
            <div className="nc-side-head nc-side-head-row">
              <h3>Notification récente</h3>
              <a href="/">Tout voir</a>
            </div>
            <div className="nc-recent-list">
              <RecentItem icon={CalendarIcon} tone="green" title="Trajet confirmé" desc="Votre trajet Yaoundé → Douala du 24 mai à 08:00 est confirmé." time="Il y a 10 min" status="Cet appareil" />
              <RecentItem icon={TagIcon} tone="violet" title="Offre spéciale" desc="-20% sur vos trajets ce week-end !" time="Il y a 2 h" />
              <RecentItem icon={CardIcon} tone="orange" title="Paiement reçu" desc="Votre paiement de 3 500 FCFA a été effectué avec succès." time="Il y a 5 h" />
              <RecentItem icon={ShieldIcon} tone="blue" title="Nouvelle connexion" desc="Connexion détectée sur Android à Yaoundé, Cameroun." time="Il y a 1 jour" status="Bloqué" />
            </div>
            <button type="button" className="nc-more-btn">Voir toutes les notifications <ChevronIcon /></button>
          </article>
        </aside>
      </div>
    </>
  );
}
